/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroDatePicker from 'forms/components/inputs/ElectroDatePicker/ElectroDatePicker';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ElectroRadioGroup from 'forms/components/inputs/ElectroRadioGroup/ElectroRadioGroup';
import ElectroCheckbox from 'forms/components/inputs/ElectroCheckbox/ElectroCheckbox';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  assetStore: Object,
  form: TypeForm,
};

@translate()
@inject('assetStore')
@observer
export default class ScheduleCalMultiForm extends React.Component<*> {
  render(): React.Node {
    const { t, form }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={form.$('collectionDetails').label}
          >
            <ElectroDatePicker field={form.$('collectionDetails.collectionDate')} />
            <ElectroRadioGroup field={form.$('collectionDetails.collectLocation')} />
            <ElectroRadioGroup field={form.$('collectionDetails.contactDetails')} />
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('additionalInformation').label}>
            <div className={styles['form-group']}>
              <ElectroCheckbox field={form.$('additionalInformation.replacementRequired')} />
              <ElectroCheckbox field={form.$('additionalInformation.keepOriginalPackaging')} />
            </div>
            {!form.$('additionalInformation.keepOriginalPackaging').value && (
              <div className={styles['form-group']}>
                <ElectroTextField
                  field={form.$('additionalInformation.packagingDescription')}
                  props={{
                    multiline: true,
                    rows: 3,
                  }}
                />
              </div>
            )}
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.schedule')} />
      </React.Fragment>
    );
  }
}
